import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Row, Col, Spinner } from 'reactstrap';
import NavBar from '../NavBar/navBar';
import { analyzeAuditoria } from '../../actions';
import './auditoriaLojas.css';

const AuditoriaLojas = () => {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [reportHtml, setReportHtml] = useState('');

    const handleFileChange = (event) => {
        const selected = (event.target.files || [])[0] || null;
        setFile(selected);
        setError('');
        setReportHtml('');
    };

    const handleAnalyze = async () => {
        if (!file) {
            setError('Selecione a planilha de auditoria (.xlsx, .xls ou .csv) antes de gerar o relatório.');
            return;
        }
        setLoading(true);
        setError('');
        setReportHtml('');
        try {
            const response = await dispatch(analyzeAuditoria(file));
            setReportHtml(response.data);
        } catch (err) {
            const responseData = err && err.data;
            const detail = responseData && (responseData.error || responseData.detalhe);
            setError(detail || 'Não foi possível gerar o relatório. Verifique a planilha e tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-layout">
            <NavBar />
            <div className="dashboard-overview auditoria-page">
                <Row className="auditoria-header">
                    <Col>
                        <h2>Auditoria de Lojas</h2>
                        <p className="auditoria-subtitle">
                            MVP: envie a planilha de auditoria (.xlsx, .xls ou .csv). O sistema lê as
                            colunas automaticamente, destaca as numéricas por cor e monta um relatório
                            com busca, clique para detalhes e exportação em PDF.
                        </p>
                    </Col>
                </Row>

                <Row className="auditoria-controls" data-tut="reactour__auditoriaUpload">
                    <Col md={12} className="auditoria-upload-row">
                        <input
                            type="file"
                            accept=".xlsx,.xls,.csv"
                            onChange={handleFileChange}
                            className="auditoria-file-input"
                        />
                        <Button color="primary" onClick={handleAnalyze} disabled={loading || !file}>
                            {loading ? <><Spinner size="sm" /> Gerando...</> : 'Gerar relatório'}
                        </Button>
                        {file &&
                            <div className="auditoria-file-count">{file.name}</div>
                        }
                    </Col>
                </Row>

                {error &&
                    <Row><Col><div className="auditoria-error">{error}</div></Col></Row>
                }

                {loading &&
                    <Row><Col>
                        <div className="auditoria-loading-note">
                            Lendo a planilha e montando o relatório — pode levar alguns instantes
                            dependendo do tamanho do arquivo.
                        </div>
                    </Col></Row>
                }

                {reportHtml &&
                    <iframe
                        title="Relatório de Auditoria"
                        className="auditoria-report-frame"
                        srcDoc={reportHtml}
                    />
                }
            </div>
        </div>
    );
};

export default AuditoriaLojas;
